module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "p-r-15"
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #878d99",
      "padding": "10px",
      "background": "white",
      "margin-bottom": "20px"
    }
  }, [_c('h4', [_vm._v("Event Data (Last 24 hours) ")]), _vm._v(" "), _c('h6', [_c('i', [_c('b', [_vm._v("Last Updated")]), _vm._v(" - " + _vm._s(_vm.currentTime) + " (PST/PDT)")])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.eventLoader),
      expression: "eventLoader"
    }],
    staticStyle: {
      "width": "100%",
      "border": "1px solid #878d99",
      "padding": "5px"
    },
    attrs: {
      "data": _vm.eventData,
      "height": "250"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "timeslot",
      "label": "Time",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "requests",
      "label": "Requests"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bids",
      "label": "Bids"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rejects",
      "label": "Rejects"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "wins",
      "label": "Wins"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "invalid_wins",
      "label": "Invalid Wins"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sib_impressions",
      "label": "SIB Impressions",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serp_clicks",
      "label": "SERP Clicks"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spend",
      "label": "Spend"
    }
  })], 1), _vm._v(" "), _c('h4', [_vm._v("Revenue Data (Last 24 hours)")]), _vm._v(" "), _c('h6', [_c('i', [_c('b', [_vm._v("Last Updated")]), _vm._v(" - " + _vm._s(_vm.currentTime) + " (PST/PDT)")])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.revenueLoader),
      expression: "revenueLoader"
    }],
    staticStyle: {
      "width": "100%",
      "border": "1px solid #878d99",
      "padding": "5px"
    },
    attrs: {
      "data": _vm.revenueData,
      "height": "250"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "timeslot",
      "label": "Time",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clicks",
      "label": "Clicks"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "revenue",
      "label": "Revenue"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rpc",
      "label": "RPC"
    }
  })], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7b1a8017!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/AdspotData.vue
// module id = 714
// module chunks = 2